import React, { useCallback } from "react";
import { Checkbox as MUICheckbox } from "@material-ui/core";
import type { FC } from "react";
import { useStyles } from "./Checkbox.styles";
import type { ICheckboxProps } from "./Checkbox.types";

export const Checkbox: FC<ICheckboxProps> = (props) => {
  const classes = useStyles();
  const { checked, onChangeChecked, disabled } = props;

  const handleChangeChecked = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      onChangeChecked(checked);
    },
    [onChangeChecked]
  );

  return (
    <MUICheckbox classes={{ root: classes.rootCheckbox }} color="primary" onChange={handleChangeChecked} checked={checked} disabled={disabled} />
  );
};
